<script>
import { Doughnut } from "vue-chartjs";

export default {
  name: "DoughnutGraph",
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.draw();
  },
  watch: {
    labels: {
      deep: true,
      handler() {
        if (this._isMounted) {
          this.draw();
        }
      },
    },
    datasets: {
      deep: true,
      handler() {
        if (this._isMounted) {
          this.draw();
        }
      },
    },
  },
  methods: {
    draw() {
      const labels = this.labels.length ? this.labels : ["No messages"];
      const source = this.datasets.length
        ? this.datasets
        : [
            {
              data: [1],
              backgroundColor: ["#e0e0e0"],
              borderWidth: 1,
            },
          ];
      this.renderChart(
        {
          labels: labels,
          datasets: source.map(set => ({
            ...set,
            data: labels.map((_, index) =>
              set.data && set.data[index] != null ? set.data[index] : 0
            ),
            backgroundColor: Array.isArray(set.backgroundColor)
              ? set.backgroundColor.slice()
              : set.backgroundColor,
          })),
        },
        this.options
      );
    },
  },
};
</script>
